/** Screen words and tones for fluid samples (PRD §9.6). Every sample screen reads these; none types its own. */
import type { AttentionFlag, FluidType, FsrMatch, SampleStatus } from '@officehub/shared';
import type { StatusTone } from '../shared/statusTone';

export const FLUID_LABELS: Record<FluidType, string> = { oil: 'Oil', coolant: 'Coolant', fuel: 'Fuel' };

export const STATUS_LABELS: Record<SampleStatus, string> = {
  expected: 'Bottle not logged',
  logged: 'Logged',
  sent: 'Shipped',
  resulted: 'Report received',
  closed: 'Closed',
  lost: 'Lost',
  cancelled: 'Cancelled',
};

/** PRD §9.6 tone mapping. A resulted sample's tone later depends on its verdict (Phase 1). */
export const STATUS_TONE: Record<SampleStatus, StatusTone> = {
  expected: 'neutral',
  logged: 'active',
  sent: 'active',
  resulted: 'done',
  closed: 'done',
  lost: 'blocked',
  cancelled: 'neutral',
};

export const FSR_MATCH_LABELS: Record<FsrMatch, string> = {
  confirmed: 'Matches FSR',
  awaiting_fsr: 'Waiting for FSR',
  not_on_fsr: 'Not on FSR — check with the technician',
  unit_mismatch: 'Unit differs from FSR',
  fsr_only: 'Bottle not logged',
};

export const FSR_MATCH_TONE: Record<FsrMatch, StatusTone> = {
  confirmed: 'done',
  awaiting_fsr: 'neutral',
  not_on_fsr: 'attention',
  unit_mismatch: 'attention',
  fsr_only: 'neutral',
};

export const FLAG_LABELS: Record<AttentionFlag, string> = {
  check_fsr: 'Check FSR',
  needs_ticket: 'Needs ticket',
  bottle_not_received: 'Bottle not received',
  not_shipped: 'Not shipped',
  overdue_at_lab: 'Overdue at lab',
  new_report: 'New report',
  action_required: 'Action required',
  lost: 'Lost',
};

export const FLAG_TONE: Record<AttentionFlag, StatusTone> = {
  check_fsr: 'attention',
  needs_ticket: 'attention',
  bottle_not_received: 'blocked',
  not_shipped: 'attention',
  overdue_at_lab: 'blocked',
  new_report: 'active',
  action_required: 'attention',
  lost: 'blocked',
};

/** Keys match the server's LOST_REASONS (functions/src/fluid-samples/services/sampleEdits.ts). */
export const LOST_REASON_LABELS: Record<string, string> = {
  lost_in_transit: 'Lost in transit',
  broken: 'Broken or leaked',
  lab_never_received: 'Lab never received it',
  never_reached_office: 'Never reached the office',
  other: 'Other',
};
